module.exports = __webpack_public_path__ + "img/bookcase-md-top.1c302999.svg";